"use client";

import { ThemeProvider } from "@caffeina-siad/ui-kit";
import * as S from "@caffeina-siad/ui-kit/src/components/layouts/Page/Page.styles";

type BaseLayoutProps = {
  children: React.ReactNode;
};

export default function BaseLayout({ children }: BaseLayoutProps) {
  return (
    <ThemeProvider>
      <S.Page>{children}</S.Page>
    </ThemeProvider>
  );
}
